import { useRouter } from 'next/router';
import type { FC } from 'react';
import React, { useEffect, useMemo, useState } from 'react';
import { FreeSubscription, VideoDescriptionLogin } from '@/Module/Auth/Component';
import { isShadUser } from '@/Module/Auth/Helper';
import { useCompleteSteps } from '@/Module/Auth/Hook';
import { putReferTypePersonAction } from '@/Module/Auth/Store/Action';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const AuthReferType: FC = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const onCompleteSteps = useCompleteSteps();
  const [referType, setReferType] = useState<string>('8');
  const section = useAppSelector(state => state.auth.section);
  const isSubscription = useMemo(() => {
    if (router.query) {
      return router.query?.redirectUrl?.includes('subscription');
    }
    return false;
  }, [router]);
  const onclick = () => {
    if (isSubscription) {
      onCompleteSteps({});
    } else dispatch(putReferTypePersonAction({
      userReferTypeId: Number(referType)
    }));
  };
  useEffect(() => {
    if (!isShadUser()) return;
    setReferType('4');
    onclick();
  }, []);
  if (section === 510) return null;
  return <div className="auth-referType" data-sentry-component="AuthReferType" data-sentry-source-file="AuthReferType.tsx">
      {section === 2 && <VideoDescriptionLogin />}
      {section === 4 && <FreeSubscription />}
    </div>;
};
export default AuthReferType;